import React, {PureComponent} from 'react';
import MenuIcon from 'mdi-react/MenuIcon';
import {changeSidebarVisibility, changeMobileSidebarVisibility} from '../../../redux/SideBar';
import {connect} from 'react-redux';
import log from '../../../helpers/logger';

const icon = process.env.PUBLIC_URL + '/img/burger.svg';

class TopbarSidebarButton extends PureComponent {
  constructor(props) {
    super(props);
  }
  
  changeSidebarVisibility = () => {
    this.props.dispatch(changeSidebarVisibility());
  };
  
  changeMobileSidebarVisibility = () => {
    this.props.dispatch(changeMobileSidebarVisibility());
  };
  
  render() {
    const menuList = (this.props.menu || {}).menuList || [];
    return (
      <div>
        {(menuList.length > 0 && !(this.props.global || {}).hideTopbarMenu) && <button className='topbar__button topbar__button--desktop' onClick={this.changeSidebarVisibility}>
          <MenuIcon className='topbar__button-icon'/>
        </button>}
        {(menuList.length > 0 && !(this.props.global || {}).hideTopbarMenu) && <button className='topbar__button topbar__button--mobile' onClick={this.changeMobileSidebarVisibility}>
          <MenuIcon className='topbar__button-icon'/>
        </button>}
      </div>
    )
  }
}

export default connect(state => {
  return {
    sidebar: state.sidebar,
    menu: (state.auth || {}).menu,
    global: state.global,
  };
})(TopbarSidebarButton);




// WEBPACK FOOTER //
// ./src/pages/_layout/topbar/TopbarSidebarButton.js